import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { useState } from "react";

type InquiryDialogProps = {
  open: boolean;
  onClose: () => void;
  onFinish: (form: any) => void;
};

export function InquiryDialog({ open, onClose, onFinish }: InquiryDialogProps) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    school: "",
    type: "",
    content: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const isFormComplete = Object.values(form).every(value => value.trim() !== "");

  const inquiryTypes = [
    "서비스 기능 문의",
    "로그인 문의",
    "스마트펜 문의",
    "기타",
  ];

  const handleChange = (key: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [key]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const response = await fetch("https://script.google.com/macros/s/AKfycbzmJPfdGT2JGyXfskyonJP7gKr5fcDqsFlagTNS-JB4WM0pPRCCgUqAk9qPM4mlZf_d/exec", {
        method: "POST",
        body: JSON.stringify(form),
      });

      setIsLoading(false);

      if (response.ok) {
        onFinish(form);
        onGoingToCallOnClose();
      } else {
        alert("제출 실패: 서버 오류");
      }
    } catch (error) {
      alert("제출 실패: 네트워크 오류");
      console.error(error);
    }
  };

  const onGoingToCallOnClose = () => {
    // clean up
    setForm({ name: "", email: "", school: "", type: "", content: "" });
    setIsLoading(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }} fullWidth maxWidth="sm">
      <DialogTitle sx={{ m: 0, p: 2 }}>
        문의하기
        <IconButton
          aria-label="close"
          onClick={onGoingToCallOnClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {isLoading && <CircularProgress sx={{ mb: 2 }} />}
        <Typography variant="body2" sx={{ mb: 2 }}>
          양식을 작성해 주시면 곧 연락드리겠습니다.
          <br />
          <span style={{ color: "red" }}>*선생님만 작성하실 수 있습니다.</span>
        </Typography>
        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            label="이름"
            fullWidth
            value={form.name}
            onChange={handleChange("name")}
          />
          <TextField
            label="이메일 주소"
            fullWidth
            value={form.email}
            onChange={handleChange("email")}
          />
          <TextField
            label="학교명"
            fullWidth
            value={form.school}
            onChange={handleChange("school")}
          />
          <TextField
            select
            label="문의 유형"
            fullWidth
            value={form.type}
            onChange={handleChange("type")}
          >
            {inquiryTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="문의 내용"
            fullWidth
            multiline
            minRows={4}
            value={form.content}
            onChange={handleChange("content")}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button disabled={!isFormComplete || isLoading} onClick={handleSubmit} variant="contained" fullWidth sx={{ mt: 1 }}>
          제출하기
        </Button>
      </DialogActions>
    </Dialog>
  );
}
